// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workReportFilterWrapper {
  display: flex;
  margin-bottom: 20px;
  gap: 10px;
  flex-wrap: wrap;
  align-items: end;
}

.workReportWrapper {
  background-color: #fff;
  overflow-x: auto;
}

.workReportWrapper table {
  width: 100% !important;
  table-layout: auto;
}

.workReportWrapper table td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.workReportWrapper th {
  padding: 4px 10px;
  border: 1px solid rgb(169, 169, 169);
  background-color: rgb(58, 87, 232, 0.2);
}
.workReportWrapper td {
  padding: 4px 10px;
  border: 1px solid rgb(169, 169, 169);
}
.highlight-row {
  background-color: rgb(58, 87, 232, 0.3);
}
.bold-row {
  font-weight: 700;
}

@media (max-width: 750px) {
  .workReportWrapper th {
    font-size: 14px !important;
  }
  .workReportWrapper td {
    font-size: 14px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/workReport/workReport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".workReportFilterWrapper {\n  display: flex;\n  margin-bottom: 20px;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: end;\n}\n\n.workReportWrapper {\n  background-color: #fff;\n  overflow-x: auto;\n}\n\n.workReportWrapper table {\n  width: 100% !important;\n  table-layout: auto;\n}\n\n.workReportWrapper table td {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.workReportWrapper th {\n  padding: 4px 10px;\n  border: 1px solid rgb(169, 169, 169);\n  background-color: rgb(58, 87, 232, 0.2);\n}\n.workReportWrapper td {\n  padding: 4px 10px;\n  border: 1px solid rgb(169, 169, 169);\n}\n.highlight-row {\n  background-color: rgb(58, 87, 232, 0.3);\n}\n.bold-row {\n  font-weight: 700;\n}\n\n@media (max-width: 750px) {\n  .workReportWrapper th {\n    font-size: 14px !important;\n  }\n  .workReportWrapper td {\n    font-size: 14px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
